import { render, staticRenderFns } from "./UiFiles.vue?vue&type=template&id=57a592a4&lang=pug&"
import script from "./UiFiles.vue?vue&type=script&lang=js&"
export * from "./UiFiles.vue?vue&type=script&lang=js&"
import style0 from "./UiFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports